import styled, { keyframes } from 'styled-components';
import React, { ReactNode, useEffect, useRef, useState } from 'react';

const FlashingAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: .3;
  }
  100% {
    opacity: 1;
  }
`;

export const Skeleton = styled.span<{
  width?: string;
  height?: string;
  br?: string;
}>`
  display: block;
  min-width: ${(props) => (props.width ? props.width : `auto`)};
  min-height: ${(props) => (props.height ? props.height : `auto`)};
  background: rgba(114, 120, 137, 0.1);
  border-radius: ${(props) => props.br || `0.5rem`};
  animation: ${FlashingAnimation} linear 1.5s infinite;
`;
interface DelayedRenderProps {
  children: ReactNode;
  delay?: number;
}

const DelayedRender: React.FC<DelayedRenderProps> = ({ children, delay }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay || 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
export default DelayedRender;
interface LazyVisibleProps {
  children: ReactNode;
  rootMargin?: string;
  threshold?: number;
}

export const LazyVisible: React.FC<LazyVisibleProps> = ({
  children,
  rootMargin = `1000px`,
  threshold = 0.1,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!ref.current || isVisible) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { rootMargin, threshold },
    );
    observer.observe(ref.current);
    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [isVisible]);

  return <div ref={ref}>{isVisible ? children : <Skeleton />}</div>;
};
